export default "__VITE_ASSET__f3a764d8__"